@if (user$ | async; as user) {
  @if (!(isLocked$ | async)) {
    <ion-button
      fill="clear"
      id="user-profile-trigger"
      class="profile-button"
      (click)="openPopover($event)"
    >
      @if (updateDownloading$ | async) {
        <ion-spinner name="crescent" class="avatar-spinner"></ion-spinner>
      } @else if (user.photoURL) {
        <ion-avatar class="avatar-small">
          <img [src]="user.photoURL" [alt]="user.displayName || 'User'" />
        </ion-avatar>
      } @else {
        <ion-icon name="person-circle" class="avatar-icon"></ion-icon>
      }
    </ion-button>

    <ion-popover #popover [dismissOnSelect]="false" (didDismiss)="isPopoverOpen = false">
      <ng-template>
        <ion-content class="popover-content">
          <div class="profile-header">
            @if (user.photoURL) {
              <ion-avatar class="avatar-large">
                <img [src]="user.photoURL" [alt]="user.displayName || 'User'" />
              </ion-avatar>
            } @else {
              <ion-icon name="person-circle" class="avatar-icon-large"></ion-icon>
            }
            <p class="user-email">{{ user.email }}</p>
          </div>
          @if (isTenantsLoading) {
            <crowdctrl-loading-card
              layout="panel"
              [message]="'Loading ' + accountLabelPluralLower + '...'"
            ></crowdctrl-loading-card>
          } @else if (availableTenants.length > 0) {
            <crowdctrl-list lines="none">
              <ion-item>
                <crowdctrl-select
                  [label]="accountLabel"
                  labelPlacement="stacked"
                  [value]="selectedTenantId"
                  [disabled]="isTenantSelectorDisabled"
                  (ionChange)="onTenantChange($event)"
                  [interfaceOptions]="{ header: 'Select ' + accountLabel }"
                  [placeholder]="'Select ' + accountLabel"
                >
                  @for (tenant of availableTenants; track tenant.id) {
                    <ion-select-option [value]="tenant.id">
                      {{ tenant.name }}
                    </ion-select-option>
                  }
                </crowdctrl-select>
              </ion-item>
            </crowdctrl-list>
          }
          <div class="popover-divider popover-divider--below-account"></div>
          <crowdctrl-list lines="none">
            <ion-item button (click)="goToHome()" detail="false">
              <ion-icon name="home" slot="start" color="medium"></ion-icon>
              <ion-label>Home</ion-label>
            </ion-item>
            <ion-item button (click)="goToSettings()" detail="false">
              <ion-icon name="settings" slot="start" color="medium"></ion-icon>
              <ion-label>Settings</ion-label>
            </ion-item>
          </crowdctrl-list>
          <div class="popover-divider"></div>
          <crowdctrl-list lines="none">
            <ion-item button (click)="signOut()" detail="false">
              <ion-icon name="log-out" slot="start" color="medium"></ion-icon>
              <ion-label>Sign Out</ion-label>
            </ion-item>
          </crowdctrl-list>
        </ion-content>
      </ng-template>
    </ion-popover>
  }
}
